import React from 'react'

const PageLoader = () => {
  return (
    <div>
      <h6
        className="text-center font-weight-bold p-5"
      >
        Loading...
      </h6>
    </div>
  )
}

export default PageLoader
